import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const yogaSteps = [
  {
    number: 1,
    title: 'Create a Calm Environment',
    description: 'Find a quiet space where you can relax without distractions. Dim the lights and get comfortable.'
  },
  {
    number: 2,
    title: 'Move with Awareness',
    description: 'Flow through the poses slowly and deliberately. Focus on the sensations in your body.'
  },
  {
    number: 3,
    title: 'Embrace Restorative Poses',
    description: 'Spend extra time in supported poses that allow your body to fully relax and release tension.'
  },
  {
    number: 4,
    title: 'Deep Breathing Practice',
    description: 'Use deep, diaphragmatic breathing throughout. Let each exhale help you sink deeper into relaxation.'
  }
];

const YogaFlowSession3: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Yoga Flow Session 3',
      description: 'Completed Yoga Flow Session 3.',
      image: require('../assets/yoga.png').default || require('../assets/yoga.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/yoga-flow');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 3: Relaxation Flow</h1>
              <p className="session-description">
                Unwind and restore with gentle, calming yoga poses. Perfect for releasing stress and finding inner peace.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/4pKly2JojMw"
                  title="Session 3: Relaxation Flow"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Practice</h2>
                <div className="session-steps">
                  {yogaSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default YogaFlowSession3;

